'use strict';

var useMatchDevice = require('./useMatchDevice.js');

const useActiveDevice = () => {
    const matches = {
        mobile: useMatchDevice.useMatchDevice('mobile'),
        tablet: useMatchDevice.useMatchDevice('tablet'),
        laptop: useMatchDevice.useMatchDevice('laptop'),
        desktop: useMatchDevice.useMatchDevice('desktop'),
    };
    const deviceNames = Object.keys(matches);
    return deviceNames.find(device => matches[device]) || null;
};

exports.useActiveDevice = useActiveDevice;
//# sourceMappingURL=useActiveDevice.js.map
